/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ApiKeyCreated interface.
 */
export function instanceOfApiKeyCreated(value) {
    if (!('keyHash' in value) || value['keyHash'] === undefined)
        return false;
    if (!('prefix' in value) || value['prefix'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('authorizedPermissions' in value) || value['authorizedPermissions'] === undefined)
        return false;
    if (!('autoGenerated' in value) || value['autoGenerated'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    return true;
}
export function ApiKeyCreatedFromJSON(json) {
    return ApiKeyCreatedFromJSONTyped(json, false);
}
export function ApiKeyCreatedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keyHash': json['key_hash'],
        'prefix': json['prefix'],
        'label': json['label'],
        'authorizedPermissions': json['authorized_permissions'],
        'autoGenerated': json['auto_generated'],
        'createdAt': (new Date(json['created_at'])),
        'lastUsedAt': json['last_used_at'] == null ? undefined : (new Date(json['last_used_at'])),
        'revokedAt': json['revoked_at'] == null ? undefined : (new Date(json['revoked_at'])),
        'key': json['key'],
    };
}
export function ApiKeyCreatedToJSON(json) {
    return ApiKeyCreatedToJSONTyped(json, false);
}
export function ApiKeyCreatedToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key_hash': value['keyHash'],
        'prefix': value['prefix'],
        'label': value['label'],
        'authorized_permissions': value['authorizedPermissions'],
        'auto_generated': value['autoGenerated'],
        'created_at': ((value['createdAt']).toISOString()),
        'last_used_at': value['lastUsedAt'] == null ? undefined : (value['lastUsedAt'].toISOString()),
        'revoked_at': value['revokedAt'] == null ? undefined : (value['revokedAt'].toISOString()),
        'key': value['key'],
    };
}
